import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {handleErrors} from "../misc/handle-errors.decorator";
import {SearchHelpers} from "../helpers/search-helper";
import {AssetService} from "./asset.service";
import {toggleLoading} from "../misc/loading.decorator";

export interface SelectAccessorySoftwareDialogModel {
  typeModal: string;
  siteId: string;
  deviceName: string;
  assetId: string;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./select-accessory-software-dialog.template.pug",
})
export class SelectAccessorySoftwareDialogComponent
  extends DialogComponent<SelectAccessorySoftwareDialogModel, any> implements SelectAccessorySoftwareDialogModel {
  typeModal: string = "";
  siteId: string;
  deviceName: string;
  assetId: string;
  loading: boolean = false;
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  solutions: any[] = [];
  solutionsFiltered: any[] = [];
  solutionsDisplay: any[] = [];
  public error: Error;

  cancel(): void {
    this.result = {};
    this.close();
  }

  async ready() {
    await this.loadAccessoriesSoftwareList();
    this.loadSolutionsToDisplay();
  }

  @toggleLoading()
  @handleErrors()
  async loadAccessoriesSoftwareList() {
    this.loading = true;
    this.solutions = await this.assetService.getSoftwareAccessories(this.siteId, this.typeModal);
    this.solutions.forEach((solution) => {
      if (solution.assetId === this.assetId) {
        solution.currentAssociation = "To the current asset";
        solution.disabled = true;
      } else if (solution.assetId) {
        solution.currentAssociation = "To another current asset";
        solution.disabled = true;
      } else {
        solution.currentAssociation = "";
        solution.disabled = false;
      }
    });

    this.loading = false;
  }

  private loadSolutionsToDisplay() {
    
    if(this.pageSize && (typeof this.pageSize === 'string')){
      this.pageSize = Number(this.pageSize);
    }

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.totalCount = this.solutions.length;
    this.solutionsFiltered = this.solutions.filter((software) => {
      if (this.searchText) {
        const values = [
          software.productDescription,
        ];

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;
        if (searchFailures) return false;
      }

      return true;
    });

    this.maxPages = Math.ceil(this.solutionsFiltered.length / (+this.pageSize));

    this.solutionsDisplay = [
      ...(this.solutionsFiltered.slice(start, end)),
    ];
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.loadSolutionsToDisplay();
  }

  @toggleLoading()
  @handleErrors()
  async saveSelection(): Promise<void> {
    this.loading = true;
    const selectedOptions = this.solutions.filter(so => so.selected);
    this.result = await this.assetService.linkAccessoriesSoftwareAsset(this.assetId, this.typeModal, selectedOptions);
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    public assetService: AssetService,
  ) {
    super(dialogService);
  }
}
